import {Directive, ElementRef, Input, OnChanges, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as moment from 'moment/moment';
import * as _ from 'lodash';

import {getState} from '../utils';
import {selectProjectRegionTimeFormats} from '../../selectors/region.selector';
import {DateFormatType, RegionInfo} from '../../models/region.model';
import {ISOUiTimestampFormat, StandardDateFormatString, StandardDateTimeFormatString} from '../../../../common/date-format.constants';

@Directive({
  selector: '[stDateFormat]'
})
export class DateFormatDirective implements OnChanges, OnInit {
  regionFormats: RegionInfo;
  @Input() stDateFormat: DateFormatType;
  @Input() dateStringValue: string;
  @Input() expectedDateFormat: typeof StandardDateFormatString | typeof ISOUiTimestampFormat | typeof StandardDateTimeFormatString;
  @Input() isDisplayLocalTimezone: boolean;
  formattedDateString: string;
  constructor(private _el: ElementRef, private _store: Store) {
    this.regionFormats = getState(this._store, selectProjectRegionTimeFormats);
  }

  ngOnInit(): void {
    if (!this.stDateFormat) {
      throw new Error('Date format is missing');
    }
    if (!this.expectedDateFormat) {
      throw new Error('Expected Date format is missing');
    }
  }

  private _setDate(dateString: string): void {
    this._el.nativeElement.textContent = dateString;
    this._el.nativeElement.value = dateString;
  }

  ngOnChanges(): void {
    if (_.isEmpty(this.dateStringValue) || this.dateStringValue === '--') { // set the text content of an element to the default ('--') or empty value
      this._setDate(this.dateStringValue);
      return;
    }
    // STF-27175: This condition will display local timezone for last modified date
    if (this.isDisplayLocalTimezone) {
      this.formattedDateString = moment.utc(_.trim(this.dateStringValue), this.expectedDateFormat).local().format(this.regionFormats[this.stDateFormat]);
    } else {
      this.formattedDateString = moment.utc(_.trim(this.dateStringValue), this.expectedDateFormat).format(this.regionFormats[this.stDateFormat]);
    }
    this._setDate(this.formattedDateString);
  }
}
